var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.2ae08310e69c2a97898416bb4c7cb3c6.svg#s';
                    var viewUrl = 'sprites.2ae08310e69c2a97898416bb4c7cb3c6.svg#view-s';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 104 36',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };